import { QuotationHistorical } from '../../../../../shared/types/modules/quotation';

export interface QuotationHistoricalProps {
    historical: QuotationHistorical[];
    showHistorical?: boolean;
}

export const fieldEquivalences: { [key: string]: string } = {
    createdAt: 'Fecha de creación',
    callId: 'Call ID',
    typeQuotation: 'Tipo de cotización',
    typification: 'Tipificación',
    subtypification: 'Subtipificación',
    bouquet: 'Ramo',
};
